<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12">
        <v-text-field label="Title" v-model="crud.title" :rules="[rules.required]"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-file-input
          label="Video"
          accept="video/*"
          v-model="crud.lesson_file"
          show-size
          prepend-icon
          append-icon="mdi-video"
        >
        <template
            v-slot:selection
            v-if="typeof crud.lesson_file === 'string'"
          >You already saved a file. Click to save a new one...</template></v-file-input>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="crud.rich_title" label="Rich Text Title" :rules="[rules.required]"></v-text-field>
      </v-col>
      <v-col cols="12">
        <span class="font-weight-semibold">
          Introduction Rich Text Here
          <v-icon size="20" class="mb-1" color="black">mdi-arrow-down</v-icon>
        </span>
        <app-editor ref="editor" v-model="crud.rich_text"></app-editor>
      </v-col>
    </v-row>
    <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto">Save</v-btn>
  </v-form>
</template>
<script>
import Editor from '@/components/Utils/Editor.vue';
import rulesMixin from '@/mixins/rulesMixin';
import restoreMixin from '@/mixins/restoreMixin';
import { getLessonIntro, postLessonIntro } from '@/api/api';

export default {
  components: {
    appEditor: Editor,
  },
  mixins: [rulesMixin, restoreMixin],
  data() {
    return {
      loading: false,
      crud: {
        title: '',
        lesson_file: undefined,
        rich_title: '',
        rich_text: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  type: 'text',
                  text: 'Rich Text here...',
                },
              ],
            },
          ],
        },
      },
    };
  },
  computed: {
    teacher_lesson: {
      get() {
        return this.$store.getters['admin/teacher_lesson'];
      },
      set(value) {
        this.$store.commit('admin/teacher_lesson', value);
      },
    },
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let crud = { ...this.crud };
      try {
        crud.rich_text = JSON.stringify(crud.rich_text);
        crud.teacher_lesson = this.teacher_lesson.uuid;
        const response = await postLessonIntro(crud);
        let teacher_lesson = { ...this.teacher_lesson };
        teacher_lesson.intro_step = response.data.uuid;
        this.teacher_lesson = teacher_lesson;
        this.crud.uuid = response.data.uuid;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loading = false;
    },
    async create() {
      const uuid = this.teacher_lesson.intro_step;
      if (uuid) {
        const response = await getLessonIntro(uuid);
        let crud = response.data;
        crud.rich_text = JSON.parse(crud.rich_text);
        this.crud = { ...crud };
        this.$refs.editor.editor.setContent(crud.rich_text);
      }
    },
  },
  created() {
    this.create();
  },
};
</script>